/**
 * Labels and colours for a transcode job's state.
 *
 * Re-pointed at `media_jobs` on 2026-09-08. The old set was
 * `error | done | in_progress | in_queue`, read from `hls_convert_progress` -
 * a table nothing wrote, so every screen using it was blank.
 *
 * `in_queue` and the queue position that came with it are gone: they assumed
 * one serial encoder. Jobs run in parallel on Cloud Run, so there is no
 * position to be third in - a percentage takes its place.
 */
const convertStatusMap = {
  queued: {
    label: "Queued",
    color: "#1976d2",
  },
  running: {
    label: "Processing",
    color: "#7b1fa2",
  },
  succeeded: {
    label: "Ready",
    color: "#2e7d32",
  },
  failed: {
    label: "Failed",
    color: "#d32f2f",
  },
  canceled: {
    label: "Canceled",
    color: "#616161",
  },
};

export default convertStatusMap;

/**
 * What the transcoder is doing right now, for the `stage` a running job
 * reports - shown beside the status/percentage on Media Jobs and, for the
 * three stages a track-only job can report, on the movie authoring Tracks
 * section too. One map for both screens (per the phase 3 ruling that the
 * three new stages `accepting`/`tracks`/`patching` belong wherever `stage`
 * is already given a display label) rather than a second copy in each.
 *
 * A stage this map does not know is rendered as-is - the transcoder is free
 * to report a new one before this map is updated for it.
 */
export const JOB_STAGE_LABELS = {
  probing: "Reading the source",
  accepting: "Accepting the new tracks",
  tracks: "Converting tracks",
  patching: "Patching the manifest",
  uploading: "Uploading the result",
  // The batch lane's concurrency cap (BatchCapacity, klooma_db_api): a job
  // over the cap waits here rather than failing. `queue_position` (Media
  // Jobs' Processing state) says how many are ordered ahead of it.
  waiting_for_capacity: "Waiting for a free encoder",
};
